import { clsx } from 'clsx'

interface SpinnerProps {
  /** What is loading — announced to assistive tech. */
  label?: string
  className?: string
}

/**
 * The one loading ring.
 *
 * Neutral, not gold: a spinner is not an action, and the design system keeps
 * gold for the single primary action on a view. Three pages had hand-rolled
 * gold copies of this before it existed.
 */
export function Spinner({ label = 'Loading', className }: SpinnerProps) {
  return (
    <div
      role="status"
      aria-label={label}
      className={clsx(
        'w-6 h-6 border-2 border-border-hover border-t-transparent rounded-full animate-spin',
        className
      )}
    />
  )
}
